import find from 'lodash/find'
import { useUserStore } from '@/store/userStore'

export default function ({ store, redirect, route }) {
  const userStore = useUserStore()

  if (userStore.loggedIn && !isSuperAdmin(store.state.users.user)) {
    if (
      userStore.loggedIn &&
      isPadronesUser(store.state.users.user) &&
      !isAllowedModule(store.state.users.user, route)
    ) {
      return redirect('/forbidden')
    } else if (userStore.loggedIn && !isPadronesUser(store.state.users.user)) {
      return redirect('/forbidden')
    }
  }
}

function isPadronesUser(user) {
  return user && user.auxRole && user.auxRole === 'padrones'
}

function isAllowedModule(user, route) {
  const fullPath = route.fullPath
  if (fullPath.includes('Inventory')) {
    const moduleId = fullPath.split('/').pop()
    const result = find(user.availableModules, (availableModule) => {
      return availableModule.module === moduleId
    })
    return !!result
  }
  return false
}

function isSuperAdmin(user) {
  return user && user.role && user.role === 'superadmin'
}
